@if (isModalShown) {
  <div [config]="{ show: true, backdrop: 'static', keyboard: false }" bsModal
    #autoShownModal="bs-modal"
    class="modal fade" tabindex="-1" role="dialog" aria-labelledby="terms of service">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary-dark">
          <h4 class="modal-title text-base-lightest" id="tosTitle">Terms of Service</h4>
        </div>
        <div class="modal-body">
          <p style="text-align:center;" id="tosDescription">*******************************WARNING********************************</p>
          <p style="text-align:justify;" id="tosDescription1">
            This is a U.S. General Services Administration Federal Government computer system that is
            "FOR OFFICIAL USE ONLY." This system is subject to monitoring. Individuals found performing unauthorized
            activities
            are subject to disciplinary action including criminal prosecution.
          </p>
          <p style="text-align:justify;" id="tosDescription2">
            This system contains Controlled Unclassified Information (CUI). All individuals viewing, reproducing or disposing of this information are required to protect it in accordance with 32 CFR Part 2002 and GSA Order CIO 2103.1 CUI Policy.
          </p>
          <div class="usa-checkbox">
            <input
              class="usa-checkbox__input"
              id="terms"
              aria-label="I accept the Terms of Service" [(ngModel)]="accepted"
              type="checkbox"
              name="terms"
              />
            <label class="usa-checkbox__label" for="terms">I accept the Terms of Service</label>
          </div>
        </div>
        <div class="modal-footer">
          <a target="_blank" aria-label="Click here to open Policy Regulations"
            class="usa-button usa-button--unstyled padding-105 text-center"
          href="https://www.gsa.gov/website-information/website-policies" role="button"> Policy &amp; Regulations</a>
          <button type="button" class="usa-button" [disabled]="!accepted" data-dismiss="modal" role="button"
            aria-label="OK" (click)="acknowledge()">OK
          </button>
        </div>
      </div>
    </div>
  </div>
}
